export default {"src":"/_next/static/media/hospitrax-pic.e32167b5.PNG","height":949,"width":1899,"blurWidth":0,"blurHeight":0};